import { Component, h, Prop } from '@stencil/core';
import { IconName } from '../../../ds-icon/ds-icon';
import { ActivityMapRegion, emitClickTrackerEvent } from '../../../../utils/utils';

@Component({
  tag: 'ds-social-link',
  styleUrl: 'ds-social-link.scss'
})
export class DsSocialLink {
  @Prop() isShareLink: boolean;
  @Prop() name: string;
  @Prop() rel: string;
  @Prop() target: string;
  @Prop() tooltip: string;
  @Prop() url: string;
  @Prop() iconName: IconName;

  render() {
    return (
      <a
        class='ds-social-link'
        href={this.url}
        title={this.tooltip}
        target={this.target}
        rel={this.rel}
        data-share-channel={this.name}
        data-share-tracking-analytics='FOLLOW'
        onClick={() => {
          emitClickTrackerEvent({
            componentName: ActivityMapRegion.Footer,
            title: `Footer Social Link ${this.name}`,
            url: this.url
          });
        }}
      >
        <ds-icon name={this.iconName} class='ds-social-link__icon' />
      </a>
    );
  }
}
